<script lang="ts">
    import { onMount } from 'svelte'
    import DateSelect from '../../_common/date-select.svelte'
    import { GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Grid from '../../_common/z/zgrid.svelte'
    import type { Appointment } from '../../../modules/schedulerApi/appointments/appointment'
    import { AppointmentStatus } from '../../../modules/schedulerApi/appointments/appointments.enum'
    import type { Schedule } from '../../../modules/schedulerApi/schedules/schedule'
    import LoadSpinner from '../../_common/load-spinner.svelte'

    // exclui registros apagados e bloqueios de indisponibilidade — mesmo critério global usado em dashboard-agendas.svelte
    const IGNORED_STATUS = [AppointmentStatus.agendamento_excluido, AppointmentStatus.agendamento_bloqueado]

    let dateSelect: { from: Date; to: Date } = window.api.utils.dates.today()

    onMount(() => {
        load(dateSelect.from, dateSelect.to)
    })

    let show = false
    let grid: GridClass = null

    async function load(from: Date, to: Date) {
        if (show) return
        show = true
        const [appointmentsRaw, schedulesRaw]: [Appointment[], Schedule[]] = await Promise.all([
            window.api.schedulers.appointments.getAll({ from, to }),
            window.api.schedulers.schedules.getAll({ discardSlots: false }),
        ])
        const appointments = appointmentsRaw.filter((a) => !IGNORED_STATUS.includes(a.status))
        const schedules = schedulesRaw.filter((s) => s.status === 100)
        console.log('relat.data', appointments, schedules)
        loadGrid(appointments, schedules)
        show = false
    }

    function loadGrid(appointments: Appointment[], schedules: Schedule[]) {
        grid = new GridClass()
        grid.title = 'Faltas e cancelamentos por agenda'
        grid.cols.push(new GridCol({ content: 'Agenda' }))
        grid.cols.push(new GridCol({ content: 'Total', type: GridColTypeEnum.int, showTotal: true }))
        grid.cols.push(new GridCol({ content: 'Faltas', type: GridColTypeEnum.int, showTotal: true }))
        grid.cols.push(new GridCol({ content: 'Cancelamentos', type: GridColTypeEnum.int, showTotal: true }))
        grid.cols.push(new GridCol({ content: 'Taxa de falta', type: GridColTypeEnum.percent }))
        grid.cols.push(new GridCol({ content: 'Taxa de cancelamento', type: GridColTypeEnum.percent }))

        const rows = schedules
            .map((schedule) => {
                const items = appointments.filter((a) => a.scheduleId === schedule.scheduleId)
                const total = items.length
                const noShows = items.filter((a) => a.status === AppointmentStatus.agendamento_faltou).length
                const cancellations = items.filter(
                    (a) => a.status === AppointmentStatus.agendamento_cancelado_usuario || a.status === AppointmentStatus.agendamento_cancelado_empresa,
                ).length
                return {
                    label: schedule.label,
                    total,
                    noShows,
                    cancellations,
                    noShowRate: total > 0 ? (noShows / total) * 100 : null,
                    cancellationRate: total > 0 ? (cancellations / total) * 100 : null,
                }
            })
            // agendas sem nenhum agendamento no período não aparecem (evita divisão por zero e linhas vazias)
            .filter((row) => row.total > 0)
            .sort((a, b) => b.noShowRate + b.cancellationRate - (a.noShowRate + a.cancellationRate))

        for (const row of rows) {
            let line: GridLine = new GridLine()
            line.slots.push({ content: row.label })
            line.slots.push({ content: row.total })
            line.slots.push({ content: row.noShows })
            line.slots.push({ content: row.cancellations })
            line.slots.push({ content: row.noShowRate })
            line.slots.push({ content: row.cancellationRate })
            grid.lines.push(line)
        }
        console.log('relat.grid', grid)
        grid = grid
    }

    function dateChanged(event) {
        dateSelect = event.detail
        load(dateSelect.from, dateSelect.to)
    }
</script>

<div class="relat-body">
    <div class="acts h-print">
        <div class="date">
            <DateSelect on:change={dateChanged} />
        </div>
    </div>
    <div class="grid mt-2">
        <Grid {grid} />
    </div>
</div>
<LoadSpinner {show}></LoadSpinner>
